var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline content-list"},_vm._l((_vm.contents.slice(0, _vm.maxItems)),function(content,index){return _c('div',{key:index,staticClass:"column",class:{
      'is-one-third-desktop': !_vm.vertical,
      'is-half-tablet': !_vm.vertical,
      'is-full': _vm.vertical
    }},[_c('ContentListing',{attrs:{"content":content,"detailed":_vm.detailed}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }